export enum RegionsAcronymEnum {
  CID = 'CID',
  CCB = 'CCB',
  CAN = 'CAN',
  CSC = 'CSC',
  REG = 'REG',
}
